import { styled } from '@planne-software/uni/mui/material';

export type MonthThumbSize = 'compact' | 'comfortable';

type VariantSpec = {
  width: number;
  height: number;
  widthLg: number;
  heightLg: number;
  rowGap: string;
  columnGap: string;
  rowGapLg: string;
  columnGapLg: string;
};

const VARIANTS: Record<MonthThumbSize, VariantSpec> = {
  compact: {
    width: 6,
    height: 6,
    widthLg: 8.8,
    heightLg: 8.8,
    rowGap: '0.1vh',
    columnGap: '0.1vw',
    rowGapLg: '0.3vh',
    columnGapLg: '0.3vw',
  },
  comfortable: {
    width: 7.276,
    height: 7.198,
    widthLg: 7.276,
    heightLg: 7.198,
    rowGap: '3.6px',
    columnGap: '3.65px',
    rowGapLg: '3.6px',
    columnGapLg: '3.65px',
  },
};

const BREAKPOINT_PX = 485;
const ABOVE_BREAKPOINT = `@media (min-width: ${BREAKPOINT_PX}px)`;
const FALLBACK_SQUARE_COLOR = '#BBBBBB';

const dontForward = (prop: PropertyKey) => prop !== 'size';

export const Grid = styled('span', { shouldForwardProp: dontForward })<{ size: MonthThumbSize }>(({ size }) => {
  const v = VARIANTS[size];
  return {
    display: 'grid',
    gridTemplateColumns: `repeat(7, ${v.width}px)`,
    gridTemplateRows: `repeat(6, ${v.height}px)`,
    rowGap: v.rowGap,
    columnGap: v.columnGap,
    pointerEvents: 'none',
    [ABOVE_BREAKPOINT]: {
      gridTemplateColumns: `repeat(7, ${v.widthLg}px)`,
      gridTemplateRows: `repeat(6, ${v.heightLg}px)`,
      rowGap: v.rowGapLg,
      columnGap: v.columnGapLg,
    },
  };
});

export const Square = styled('span', { shouldForwardProp: dontForward })<{ size: MonthThumbSize }>(
  ({ theme, size }) => {
    const v = VARIANTS[size];
    return {
      display: 'block',
      width: v.width,
      height: v.height,
      borderRadius: 2,
      backgroundColor: theme?.tokens?.colors?.['fill-color-neutral-soft'] ?? FALLBACK_SQUARE_COLOR,
      [ABOVE_BREAKPOINT]: {
        width: v.widthLg,
        height: v.heightLg,
      },
    };
  },
);

export const Slot = styled('span', { shouldForwardProp: dontForward })<{ size: MonthThumbSize }>(({ size }) => {
  const v = VARIANTS[size];
  return {
    display: 'block',
    width: v.width,
    height: v.height,
    [ABOVE_BREAKPOINT]: {
      width: v.widthLg,
      height: v.heightLg,
    },
  };
});
